export default __webpack_public_path__ + "static/media/jason-tcb.a7033da2.jpeg";